/**
 * @desc list
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.financeVoucherReport.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/financeVoucherReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
